module.exports = __webpack_public_path__ + "2_View_Goal_Progress_Modal-1af57345de21ca375cab130b1e7ca737.png";